<template>
  <div class="container">
    <div class="img-newDetails"><img :src="data.informationImg"/></div>
    <div class="content-font2">
      <h1 class="text-center">{{data.title}}</h1>
      <p>{{data.content}}</p>
      <p style="text-align: right">万顺代驾司机</p>
      <p style="text-align: right">{{data.effectStartTime | formatDate}}</p>
    </div>
  </div>
</template>

<script>
  import util from '../../utils/util';
  import {
    selectById,
  } from '@/apis/new/new';
  import mobileType from '../../utils/mobileType';

  export default {
    data() {
      return {
        data: {}
      };
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      let data = decodeURIComponent(this.$route.query.data);
      console.log(data);
      this.data = JSON.parse(data);
      console.log(this.data);
      // this.getInfo();
      this.getUserInfoFromApp();
    },
    filters: {
      formatDate(val) {
        return util.timestampToTime(val);
      }
    },
    methods: {
      getUserInfoFromApp() {
        let params = {
          methodName: 'getDataFromNative',//定义与原生的方法名(固定)
          type: 1,//业务类型(固定)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
      getDataFromNative(params) {
        if (mobileType.isIOS()) {
          this.params = params;
        } else if (mobileType.isAndroid()) {
          this.params = JSON.parse(params);
        }
        this.getInfo();
      },
      // 获取数据
      async getInfo() {
        // let params = {
        //   areaCode: '110105',
        //   channel: '1020000000',
        //   data: {
        //     id: 11
        //   },
        //   deviceId: '076cf0ae-9f57-44d4-b59a-9590dedbf65b',
        //   display: '1080*2340',
        //   imei: '867215046381618',
        //   imsi: '未授权电话权限',
        //   lat: 39.898051,
        //   lon: 116.491295,
        //   platform: '3',
        //   softVersion: '4.7.8',
        //   sysVersion: 'TNY-AL00,10',
        //   token: 'MTAxNzAwMTI6NzAwOjIwMjAwODIwMTY0OTU5OTE1'
        // };
        let params = {
          areaCode: this.params.areaCode,
          channel: this.params.channel,
          data: {
            id: this.data.id
          },
          deviceId: this.params.deviceId,
          display: this.params.display,
          imei: this.params.imei,
          imsi: this.params.imsi,
          lat: this.params.lat,
          lon: this.params.lon,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          token: this.params.token,
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await selectById(params);
          if (data.code == 1 && data.data) {
            this.data = JSON.parse(data.data);
          }
        } catch (error) {
        }
      }
    },
  };
</script>
<style scoped lang="less">
  .img-newDetails {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .font-hui {
    font-size: 0.75rem;
    line-height: 1.0625rem;
    padding-top: 1.875rem;

    a {
      color: #666666;
    }
  }

</style>

